// extracted by mini-css-extract-plugin
module.exports = {"buttons":"LegendeCreneauDelete_buttons__37OHp"};